let firebaseDB = null;
let firebase = null;
let firebaseRealTimeDB = null;

export default async function getFirebase() {
  if (firebaseDB && firebaseRealTimeDB) {
    return { firebaseDB, firebase, firebaseRealTimeDB };
  }

  const firebaseFirestore = await import(/* webpackChunkName: "firebase" */ './firebase-firestore');
  firebase = firebaseFirestore.default;

  const firebaseConfig = {
    apiKey: 'AIzaSyDiAJXzol0P6Re4AKUnbtv-5-3oCTUdTKY',
    authDomain: 'lyearn.firebaseapp.com',
    databaseURL: 'https://lyearn.firebaseio.com',
    projectId: 'lyearn',
    storageBucket: 'lyearn.appspot.com',
    messagingSenderId: '561943841515',
    appId: '1:561943841515:web:8983f72e8e9be166'
  };
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
  firebaseDB = firebase.firestore();
  firebaseRealTimeDB = firebase.database();

  return { firebaseDB, firebase, firebaseRealTimeDB };
}
